
export const VALIDATION_MESSAGES = {
  MEASURE_REQUIRED: 'La misura della scatola è obbligatoria',
  QUANTITY_REQUIRED: 'La quantità di scatole è obbligatoria',
  BOTTLE_AMOUNT_REQUIRED: 'Il numero di bottiglie è obbligatorio',
  BOTTLE_SIZE_REQUIRED: 'La dimensione della bottiglia è obbligatoria',
  PAPER_QUANTITY_REQUIRED: 'Il numero di fogli è obbligatorio'
}
